import PropTypes from 'prop-types';
import { ChevronRight, GripVertical } from "lucide-react";
import { Droppable, Draggable } from '@hello-pangea/dnd';
 
const CategoryList = ({ categories = [], onCategoryClick }) => {
    return (
        <Droppable droppableId="categoryList">
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className={`mb-8 overflow-y-auto max-h-[50vh] ${snapshot.isDraggingOver ? 'bg-gray-50' : ''
                        }`}
                >
                    <div className="space-y-2 mt-6">
                        {Array.isArray(categories) && categories.map((category, index) => (
                            <Draggable
                                key={category.id.toString()}
                                draggableId={category.id.toString()}
                                index={index}
                            >
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        className={`flex items-center justify-between w-full p-4 border-b-[1px] bg-white
                                            ${snapshot.isDragging ? 'shadow-lg' : ''}
                                            transition-all duration-200`}
                                    >
                                        <div className="flex items-center gap-4 flex-1">
                                            <div
                                                {...provided.dragHandleProps}
                                                className="cursor-grab hover:text-ps-blue-dark"
                                            >
                                                <GripVertical className="h-5 w-5 text-gray-400" />
                                            </div>
                                            <span
                                                className="font-inter cursor-pointer hover:pl-2 transition-all duration-200 flex-1"
                                                onClick={() => onCategoryClick(category.id)}
                                            >
                                                {category.name}
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-4">
                                            <span className="text-ps-blue-dark font-inter w-10 text-right">
                                                {category.count}
                                            </span>
                                            <ChevronRight className="text-ps-blue-dark" size={20} />
                                        </div>
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                </div>
            )}
        </Droppable>
    );
};

CategoryList.propTypes = {
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
            ]).isRequired,
            name: PropTypes.string.isRequired,
            count: PropTypes.number.isRequired,
        })
    ),
    onCategoryClick: PropTypes.func.isRequired
};
 
export default CategoryList;